(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kime-recommendations"]) return;
  try {
    
document.querySelectorAll('.kime-recommendations').forEach((element) => {
  fetch(element.dataset.url).then((response) => {
    if (!response.ok) throw new Error('Recommendations unavailable');
    return response.text();
  }).then((text) => {
    const documentFragment = new DOMParser().parseFromString(text, 'text/html');
    const replacement = documentFragment.querySelector('.kime-recommendations');
    if (replacement && replacement.querySelector('.grid > div')) element.innerHTML = replacement.innerHTML;
  }).catch(() => {});
});

  } catch(e) { console.error(e); }
})();
})();
